import { render, staticRenderFns } from "./optButtonList.vue?vue&type=template&id=00d7a0fe&scoped=true"
import script from "./optButtonList.vue?vue&type=script&lang=js"
export * from "./optButtonList.vue?vue&type=script&lang=js"
import style0 from "./optButtonList.vue?vue&type=style&index=0&id=00d7a0fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d7a0fe",
  null
  
)

export default component.exports